import { Injectable } from '@angular/core';
import { APIService } from '@core/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class TruxService {

  constructor( private readonly apiService:APIService) { }

  authUserActiveBooking(request:{email:string, password:string}){
    return this.apiService.postWithAllResponse('BookingSlot/AuthUserActiveBooking', request);
  }

}
